/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Stock_Share_LabelInputs */

const vi_product_stock_share_label = /** @type {(inputs: Product_Stock_Share_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tỉ lệ tồn theo mức chiết khấu`)
};

/**

* @param {Product_Stock_Share_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_stock_share_label = /** @type {((inputs?: Product_Stock_Share_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Stock_Share_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_stock_share_label(inputs)
});